export default "__VITE_ASSET__f6c346b6__"